module.exports = __webpack_public_path__ + "static/img/latest-activity-deleted.6cded6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/latest-activity-deleted.svg
// module id = 1437
// module chunks = 0